import {
  Box,
  Button,
  DrawerCloseButton,
  Heading,
  Input,
  Stack,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import BackButton from "../../components/BackButton";
import EventCard from "../../components/events/EventCard";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import { MapContext } from "../../context/map.context";
import { useEvents } from "../../data/events.api";

type Props = {};

const AllEvents = (props: Props) => {
  const { data, isLoading, error } = useEvents();
  const { reset } = useContext(MapContext);
  const [searchQuery, setSearchQuery] = useState("");

  const results = useMemo(() => {
    return data?.filter((event) => {
      return (
        searchQuery.length === 0 ||
        event.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  }, [data, searchQuery]);

  useEffect(() => reset(), []);

  return (
    <HybridBottomSheetDrawer>
      <BackButton />
      <Box p={10} overflow="auto">
        <Heading size="md" mb={4}>
          Upcoming Events
        </Heading>
        <QueryStateWrapper isLoading={isLoading} data={data} error={error}>
          <Input
            variant="filled"
            placeholder="Search"
            mb={4}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {results ? (
            <Stack spacing={4}>
              {results.map((e) => (
                <EventCard event={e} />
              ))}
            </Stack>
          ) : null}
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default AllEvents;
